import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@next/core-lib/authorization';

import { ControlRoomComponent } from './control-room.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'automatic-advice',
        component: ControlRoomComponent,
        canActivate: [AuthGuard],
      },
    ]),
  ],
})
export class ControlRoomRoutingModule {}
